import React from "react";
import { Button, Col } from "react-bootstrap";

const CumstomButton = (props) => {
    return <Col lg={{ span: 30, order: 1 }}>
        <Button {...props}>
            {props.children}
        </Button>
    </Col>
}

export default CumstomButton